import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import Star from '@mui/icons-material/Star';
import default_avatar from 'assets/img/default-avatar.png';
import default_avatar_PF_man from 'assets/img/PF man.svg';
import default_avatar_PF_woman from 'assets/img/PF woman.svg';
import default_avatar_PFA from 'assets/img/PFA.svg';
import default_avatar_PJ from 'assets/img/PJ.svg';
import { MALE, FEMALE } from 'constants/genderCodes';
import { Card, IconButton } from '@totalsoft/rocket-ui';
import { ListEditIcon, ListEditLink } from 'components/common/CommonStyles';
import { PartnerListLogo } from 'features/partnerFile/PartnerFileStyles';

const PartnerFileListItem = ({ partnerFile, onEdit, fieldsToShow }) => {
  const { t } = useTranslation();

  const defaultLogo = partnerFile.isPJ
    ? default_avatar_PJ
    : partnerFile.isPF
    ? partnerFile.genderCode === MALE
      ? default_avatar_PF_man
      : partnerFile.genderCode === FEMALE
      ? default_avatar_PF_woman
      : default_avatar
    : default_avatar_PFA;

  const handleEdit = () => onEdit(partnerFile.documentId, partnerFile.siteId);

  return (
    <Card id={'partnerFileList_file_' + partnerFile.documentId}>
      <Grid container gap={3} flexWrap='nowrap'>
        <Grid item>
          <PartnerListLogo src={defaultLogo} alt='logo' />
        </Grid>
        <Grid item container spacing={1} width='auto' flexGrow={1}>
          {fieldsToShow.includes('fileNumber') && (
            <Grid item xs={12} md={4} sm={6} id={'partnerFileList_file_' + partnerFile.documentId + '_fileNumber'}>
              <strong> {t('PartnerFileList.FileNumber')}</strong>: <span>{partnerFile.fileNumber}</span>
            </Grid>
          )}
          {fieldsToShow.includes('partnerTypeName') && (
            <Grid item xs={12} md={4} sm={6} id={'partnerFileList_file_' + partnerFile.documentId + '_partnerTypeName'}>
              <strong> {t('PartnerFileList.PartnerType')}</strong>: <span>{partnerFile.partnerTypeName}</span>
            </Grid>
          )}
          {fieldsToShow.includes('partnerName') && (
            <Grid item xs={12} md={4} sm={6} id={'partnerFileList_file_' + partnerFile.documentId + '_partnerName'}>
              <strong> {t('PartnerFileList.Partner')}</strong>: <span>{partnerFile.partnerName}</span>
            </Grid>
          )}
          {fieldsToShow.includes('fileDate') && (
            <Grid item xs={12} md={4} sm={6} id={'partnerFileList_file_' + partnerFile.documentId + '_fileDate'}>
              <strong>{t('PartnerFileList.FileDate')}</strong>: <span>{t('DATE', { date: partnerFile.fileDate })}</span>
            </Grid>
          )}
          {fieldsToShow.includes('stateName') && (
            <Grid item xs={12} md={4} sm={6} id={'partnerFileList_file_' + partnerFile.documentId + '_stateName'}>
              <strong> {t('PartnerFileList.State')}</strong>: <span>{partnerFile.stateName}</span>
            </Grid>
          )}
          {fieldsToShow.includes('uniqueId') && (
            <Grid item xs={12} md={4} sm={6} id={'partnerFileList_file_' + partnerFile.documentId + '_uniqueId'}>
              <strong> {t('PartnerFileList.UniqueId')}</strong>: <span>{partnerFile.uniqueId}</span>
            </Grid>
          )}
          {fieldsToShow.includes('userName') && (
            <Grid item xs={12} md={4} sm={6} id={'partnerFileList_file_' + partnerFile.documentId + '_user'}>
              <strong> {t('PartnerFileList.User')}</strong>:{' '}
              <span>
                {partnerFile.isReplacementOffer ? <Star /> : ''} {partnerFile.userName}
              </span>
            </Grid>
          )}
          {fieldsToShow.includes('offerType') && (
            <Grid item xs={12} md={4} sm={6} id={'partnerFileList_file_' + partnerFile.documentId + '_offerType'}>
              <strong> {t('PartnerFileList.OfferType')}</strong>: <span>{partnerFile.offerTypeName}</span>
            </Grid>
          )}
        </Grid>
        <ListEditLink to={handleEdit}>
          <IconButton id='offerList_editBtn' size='small' color='primary' tooltip={t('Edit')}>
            <ListEditIcon />
          </IconButton>
        </ListEditLink>
      </Grid>
    </Card>
  );
};

PartnerFileListItem.propTypes = {
  partnerFile: PropTypes.object.isRequired,
  onEdit: PropTypes.func.isRequired,
  fieldsToShow: PropTypes.array.isRequired
};

export default PartnerFileListItem;
